import { ReactElement } from "react";
import { KXUserData } from "../Models/KXUserData";
import { ApplyEligibilityCheckResponse } from "../Data/Responses/ApplyEligibilityCheckResponse";
import { KXAccomm } from "../Components/KXAccomm";
import { KXOffers } from "../Components/KXOffers";
import { KXYear } from "../Models/KXYear";
import { GetKxAccommodationOffersForApplicantResponse } from "../Data/Responses/GetKxAccommodationOffersForApplicantResponse";
import { AppTypeRef } from "../Models/References/AppTypeRef";
import { SummerBookingRef } from "../Models/References/SummerBookingRef";
import { Link } from "react-router-dom";
import { NewTabLink } from "../Components/UI/NewTabLink";
import { LoadingBlock } from "../Components/UI/LoadingBlock";
import { SummerStatus } from "../Components/SummerStatus";
import { AdminAccess } from "../Components/AdminAccess";
// import { IsUGBallot } from "../Components/Intros/IsUGBallot";
// import { IsRetCOVID } from "../Components/Intros/IsRetCOVID";
// import { IsStudyAbroadNotOct } from "../Components/Intros/IsStudyAbroadNotOct";
// import { IsUGFinalBallot } from "../Components/Intros/IsUGFinalBallot";

export interface SummaryProps {
    KXUserData: KXUserData;
    ThisAcadYear: KXYear;
    NextAcadYear: KXYear;

    KXAppThisYearEligibility: ApplyEligibilityCheckResponse;
    KXAppThisYearOffers: GetKxAccommodationOffersForApplicantResponse;
    KxThisStudentGuid: string;
    ThisApplicationTypeID: number;

    KXAppNextYearEligibility: ApplyEligibilityCheckResponse;
    KXAppNextYearOffers: GetKxAccommodationOffersForApplicantResponse;
    KxNextStudentGuid: string;
    NextApplicationTypeID: number;

    KXAppSummerEligibility: { Error: string; Ready: boolean; };
    KXAppSummerOffers: GetKxAccommodationOffersForApplicantResponse;
    KxSummerStudentGuid: string;
    SummerApplicationTypeID: number;

    ThisStatusFlag: string;
    ThisStatusDescription: string;
    NextStatusFlag: string;
    NextStatusDescription: string;
    SummerStatusFlag: string;
    SummerStatusDescription: string;

    ThisEventID: string | undefined;
    NextEventID: string | undefined;

    Eligible: boolean;
    Campus: string;
    StudyLevel: string;
    KXError: string;

    SiteAdmins: Array<String> | undefined;
}

export function Summary(props: SummaryProps): ReactElement {
    return (
        <div className="Contents">
            <h1>My accommmodation applications</h1>

            {/*  student data fields */}

            {

                // ternary: if props and KXUserData are defined,
                // render the User Data panel,
                // otherwise render a Loading animation.

                props !== undefined && props.KXUserData !== undefined

                    ?

                    <div className="UserData_Container">
                        <fieldset className="UserData">
                            <legend className="Contents_Title_Text"> Student Information</legend>
                            <div className="UserData_column">
                                <div className="UserDataField">
                                    <span className="Title">Name:</span>
                                    <span className="Value" >{props.KXUserData.Title + " " + props.KXUserData.OtherNames + " " + props.KXUserData.Surname}</span>
                                </div>
                                <div className="UserDataField">
                                    <span className="Title">PRID:</span>
                                    <span className="Value" >{props.KXUserData.PRID}</span>
                                </div>
                                <div className="UserDataField">
                                    <span className="Title">Campus:</span>
                                    <span className="Value" >{props.KXUserData.CampusID}</span>
                                </div>
                            </div>
                            <div className="UserData_column">
                                <div className="UserDataField">
                                    <span className="Title">Study Level:</span>
                                    <span className="Value" >{props.KXUserData.LevelOfStudy}</span>
                                </div>
                                <div className="UserDataField">
                                    <span className="Title">Fees:</span>
                                    <span className="Value" >{props.KXUserData.FeeStatus}</span>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    :

                    <LoadingBlock></LoadingBlock>

            }

            {/* booking appears here (or alternatives) */}

            {
                // ternary: if the student is not eligible, and does not have an offer for this year or next year,
                // display an error,
                // otherwise display their application and accommodation data
                props.Eligible !== true
                    && props.KXAppNextYearOffers?.HasOfferDependingOnAppTypeID !== true
                    && props.KXAppThisYearOffers?.HasOfferDependingOnAppTypeID !== true

                    ?

                    <fieldset className="GatewayError">
                        <p>Our records show that you are not currently eligible to apply for accommodation, and you do not have any current offers of accomodation.</p>

                        <p>If you believe this to be wrong, please contact the Student Services Hub: <Link to='mailto:askthehub@essex.ac.uk'>askthehub@essex.ac.uk</Link>.</p>
                    </fieldset>

                    :

                    (
                        // ternary: if both This and Next year's Offers statuses are Unknown,
                        // display an error,
                        // otherwise display their application and accommodation data
                        props.KXAppNextYearOffers?.StatusFlag === "UNKNOWN" && props.KXAppNextYearOffers?.StatusFlag === "UNKNOWN")

                        ?

                        <span className="GatewayError">
                            Unknown record configuration! Please contact
                            the Student Services Hub: <Link to='mailto:askthehub@essex.ac.uk'>askthehub@essex.ac.uk</Link>.
                        </span>

                        :

                        <>
                            {
                                // ternary: if ThisEventID is set, and KxThisStudentGuid is set, and ThisApplicationTypeID is set,
                                // display their Applications and Accommodations for THIS academic year
                                // otherwise display the empty fragment (<></>)
                                props.ThisEventID !== undefined && props.ThisEventID !== null &&
                                    props.KxThisStudentGuid !== undefined && props.KxThisStudentGuid !== null &&
                                    props.ThisApplicationTypeID !== 0

                                    ?

                                    <div className="OtherData_Container">
                                        <fieldset className="OtherData">
                                            <legend>Applications for the {props.ThisAcadYear?.KXFormat} academic year</legend>
                                            <KXAccomm
                                                StatusFlag={props.KXAppThisYearOffers?.StatusFlag}
                                                StatusDescription={props.KXAppThisYearOffers?.StatusDescription}
                                                KxStudentGuid={props.KxThisStudentGuid}
                                                ApplicationTypeID={props.ThisApplicationTypeID}
                                                Campus={props.Campus}
                                                StudyLevel={props.StudyLevel}
                                                NavTo="CurrentYear"
                                            ></KXAccomm>
                                            {
                                                // ternary: If we have an OFFER or an ACCEPTed offer, display.
                                                //   otherwise, display <></> (the empty fragment).
                                                props.KXAppThisYearOffers?.StatusFlag === "OFFER" || props.KXAppThisYearOffers?.StatusFlag === "ACCEPT"
                                                    ?
                                                    <>
                                                        <p>&nbsp;</p>
                                                        <b>Your offers of accommodation</b>
                                                        <KXOffers
                                                            KXAcademicYear={props.ThisAcadYear}
                                                            KXError={props.KXError}
                                                            StatusDescription={props.KXAppThisYearOffers?.StatusDescription}
                                                            StatusFlag={props.KXAppThisYearOffers?.StatusFlag}
                                                            KxStudentGuid={props.KxThisStudentGuid}>
                                                        </KXOffers>
                                                    </>
                                                    :
                                                    <></>
                                            }
                                            <AdminAccess SiteAdmins={props.SiteAdmins}>
                                                <p className="GatewayError">
                                                    <b>Application Type:</b> {
                                                        props.ThisApplicationTypeID ?? 'apptypeid undetected'
                                                    } - {
                                                        props.ThisApplicationTypeID !== undefined && props.ThisApplicationTypeID !== null
                                                            ?
                                                            AppTypeRef[props.ThisApplicationTypeID.toString()]
                                                            :
                                                            ""
                                                    }
                                                </p>
                                            </AdminAccess>
                                        </fieldset>
                                    </div>

                                    :

                                    <></>
                            }

                            {
                                // ternary: if NextEventID is set, and KxNextStudentGuid is set, and NextApplicationTypeID
                                // display their Applications and Accommodations for the next academic year
                                // otherwise display the empty fragment (<></>)
                                props.NextEventID !== undefined && props.NextEventID !== null &&
                                    props.KxNextStudentGuid !== undefined && props.KxNextStudentGuid !== null &&
                                    props.NextApplicationTypeID !== 0

                                    ?

                                    <div className="OtherData_Container">
                                        <fieldset className="OtherData">
                                            <legend>Applications for the {props.NextAcadYear?.KXFormat} academic year</legend>
                                            <KXAccomm
                                                StatusFlag={props.KXAppNextYearOffers?.StatusFlag}
                                                StatusDescription={props.KXAppNextYearOffers?.StatusDescription}
                                                KxStudentGuid={props.KxNextStudentGuid}
                                                ApplicationTypeID={props.NextApplicationTypeID}
                                                Campus={props.Campus}
                                                StudyLevel={props.StudyLevel}
                                                NavTo="NextYear"
                                            ></KXAccomm>
                                            {
                                                // ternary: If we have an OFFER or an ACCEPTed offer, display.
                                                //   otherwise, display <></> (the empty fragment).
                                                props.KXAppNextYearOffers?.StatusFlag === "OFFER" || props.KXAppNextYearOffers?.StatusFlag === "ACCEPT"
                                                    ?
                                                    <>
                                                        <p>&nbsp;</p>
                                                        <b>Your offers of accommodation</b>
                                                        <KXOffers
                                                            KXAcademicYear={props.NextAcadYear}
                                                            KXError={props.KXError}
                                                            StatusDescription={props.KXAppNextYearOffers?.StatusDescription}
                                                            StatusFlag={props.KXAppNextYearOffers?.StatusFlag}
                                                            KxStudentGuid={props.KxNextStudentGuid}>
                                                        </KXOffers>
                                                    </>
                                                    :
                                                    <></>
                                            }
                                            <AdminAccess SiteAdmins={props.SiteAdmins}>
                                                <p className="GatewayError">
                                                    <b>Application Type:</b> {
                                                        props.NextApplicationTypeID ?? 'apptypeid undetected'
                                                    } - {
                                                        props.NextApplicationTypeID !== undefined && props.NextApplicationTypeID !== null
                                                            ?
                                                            AppTypeRef[props.NextApplicationTypeID.toString()]
                                                            :
                                                            ""
                                                    }
                                                </p>
                                            </AdminAccess>
                                        </fieldset>
                                    </div>

                                    :

                                    <></>
                            }
                            {
                                // ternary: if SummerApplicationTypeID is set, and KxThisStudentGuid is set, and NextApplicationTypeID
                                // display their Applications and Accommodations for the next academic year
                                // otherwise display the empty fragment (<></>)
                                props.SummerApplicationTypeID !== undefined && props.SummerApplicationTypeID !== null && props.SummerApplicationTypeID !== 0
                                    ?
                                    <div className="OtherData_Container">
                                        <fieldset className="OtherData">
                                            <legend>Applications for summer vacation {props.ThisAcadYear?.KXFormat.split(' ')[2]}</legend>
                                            {
                                                props.SummerApplicationTypeID === 178 || props.SummerApplicationTypeID === 179
                                                    && props.KxSummerStudentGuid !== undefined && props.KxSummerStudentGuid !== null
                                                    ?
                                                    <SummerStatus SummerStatusDescription={props.SummerStatusDescription} SummerStatusFlag={props.SummerStatusFlag} SummerApplicationTypeID={props.SummerApplicationTypeID}></SummerStatus>
                                                    :
                                                    <>
                                                        <p>{SummerBookingRef[props.SummerApplicationTypeID].Long}</p>
                                                        {
                                                            // <p>
                                                            //     If you believe this to
                                                            //     be incorrect please
                                                            //     contact <Link to="mailto:askthehub@essex.ac.uk">askthehub@essex.ac.uk</Link> or
                                                            //     use one of the other contact methods on this web
                                                            //     page: <NewTabLink to="https://www.essex.ac.uk/student/advice-and-support">
                                                            //         https://www.essex.ac.uk/student/advice-and-support
                                                            //     </NewTabLink>.
                                                            // </p>
                                                        }
                                                    </>
                                            }

                                            {
                                                // ternary: If we have an OFFER or an ACCEPTed offer, display.
                                                //   otherwise, display <></> (the empty fragment).
                                                props.KXAppSummerOffers?.StatusFlag === "OFFER" || props.KXAppSummerOffers?.StatusFlag === "ACCEPT"
                                                    ?
                                                    <>
                                                        <p>&nbsp;</p>
                                                        <b>Your offers of accommodation</b>
                                                        <KXOffers
                                                            KXAcademicYear={props.ThisAcadYear}
                                                            KXError={props.KXError}
                                                            StatusDescription={props.KXAppSummerOffers?.StatusDescription}
                                                            StatusFlag={props.KXAppSummerOffers?.StatusFlag}
                                                            KxStudentGuid={props.KxSummerStudentGuid}>
                                                        </KXOffers>
                                                    </>
                                                    :
                                                    <></>
                                            }

                                            <AdminAccess SiteAdmins={props.SiteAdmins}>
                                                <p className="GatewayError">
                                                    <b>Summer Application Response:</b> {
                                                        // ternary: if the Summer Application Type ID is set,
                                                        // render a quick application summary for debug purposes
                                                        // otherwise, render the empty fragment (<></>)
                                                        props.SummerApplicationTypeID !== undefined && props.SummerApplicationTypeID !== null ?
                                                            <>
                                                                {
                                                                    props.SummerApplicationTypeID.toString()
                                                                } - {
                                                                    SummerBookingRef[props.SummerApplicationTypeID].Short
                                                                }
                                                            </>
                                                            :
                                                            "null"
                                                    }
                                                </p>
                                            </AdminAccess>
                                        </fieldset>
                                    </div>

                                    :

                                    <></>
                            }
                        </>
            }

            <div className="OtherData_Container">
                <fieldset className="OtherData">
                    <legend>Data Protection</legend>
                    <p>
                        This is a secure web page.
                        Your data will be kept confidential and will only be disclosed to people who have a need to know in accordance with the University's notification under the Data Protection Act.
                        Our privacy statements: <NewTabLink
                            to="https://www.essex.ac.uk/disclaimer/privacy-statements">
                            https://www.essex.ac.uk/disclaimer/privacy-statements
                        </NewTabLink>.
                    </p>
                </fieldset>
            </div>
            {
                // <IsUGBallot Campus={"Colchester"} AcadYearLabel={"AcadYearLabel"} TimeClose={"TimeClose"} DateClose={"DateClose"}></IsUGBallot>
                // <IsUGFinalBallot Campus={"Colchester"} AcadYearLabel={"AcadYearLabel"} TimeClose={"TimeClose"} DateClose={""}></IsUGFinalBallot>
                // <IsStudyAbroadNotOct Campus={"Colchester"} AcadYearLabel={"AcadYearLabel"}></IsStudyAbroadNotOct>
                // <IsRetCOVID Campus={"Colchester"} AcadYearLabel={"AcadYearLabel"}></IsRetCOVID>
            }
        </div>
    );
}
